import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { height, left, position, top, width, zIndex } from 'styled-system';

import { YOUTUBE_IFRAME_OVERLAY_ICON } from '../../constants/z-index';
import { filter, transform, transition } from '../../theme/system-utilities';
import Icon from '../Icon';
import iconPlay from './youtube-play.svg?sprite';

const UnstyledIconPlay = styled(Icon)<any>`
  ${position};
  ${transform};
  ${top};
  ${left};
  ${zIndex};
  ${width};
  ${height};
  ${transition};
  ${filter};
`;

const IconPlay = (props: ComponentProps<typeof UnstyledIconPlay>) => (
  <UnstyledIconPlay
    position="absolute"
    icon={iconPlay}
    width={68}
    height={90}
    transition="filter .1s cubic-bezier(0, 0, 0.2, 1)"
    transform="translate3d(-50%, -50%, 0)"
    top="50%"
    left="50%"
    zIndex={YOUTUBE_IFRAME_OVERLAY_ICON}
    filter="grayscale(100%)"
    dataTestId="youtube-play-icon"
    {...props}
  />
);

export default IconPlay;
